var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0856 21.5861C6.1357 21.5861 3.66075 21.5861 2.12244 20.0477C0.585175 18.5115 0.585175 16.0355 0.585175 11.0856C0.585175 6.13573 0.585175 3.66078 2.12244 2.12247C3.6618 0.585205 6.1357 0.585205 11.0856 0.585205C16.0355 0.585205 18.5105 0.585205 20.0477 2.12247C21.586 3.66183 21.586 6.13573 21.586 11.0856C21.586 16.0355 21.586 18.5105 20.0477 20.0477C19.1909 20.9056 18.0421 21.2847 16.3358 21.4527",
    stroke: "#232020",
    strokeWidth: 1.17033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0856 21.5861C11.0856 20.1936 11.6387 18.8582 12.6234 17.8736C13.608 16.889 14.9434 16.3358 16.3358 16.3358M0.585175 7.9355H13.1857M17.3859 7.9355H21.586M7.93547 21.5861V7.9355M7.93547 3.73533V0.585205",
    stroke: "#232020",
    strokeWidth: 1.17033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon03.707d4d380c6abb0484d73453ede76ac4.svg";
export { ForwardRef as ReactComponent };